export const routes = {
  // tableData
  routesTitle: {
    zh: '路线',
    en: '',
    pu: 'Rotas'
  },
  createRoutesButton: {
    zh: '创建路线',
    en: '',
    pu: 'Criar rota'
  },
  idRoutesLabel: {
    zh: '路线 ID',
    en: '',
    pu: 'Rota ID'
  },
  noResults: {
    zh: '没有结果',
    en: '',
    pu: 'Sem resultados'
  },
  createRoutesTitle: {
    zh: '创建路线',
    en: '',
    pu: 'Criando Rota'
  },
  createRoutesParagraph: {
    zh: '请填写下方的字段以完成在我们系统中创建路线的操作。',
    en: '',
    pu: 'Preencha os campos logo abaixo para realizar a criação de uma rota em nosso sistema'
  },

  // actions
  edit: {
    zh: '编辑',
    en: '',
    pu: 'Editar'
  },
  seeSellers: {
    zh: '查看卖家',
    en: '',
    pu: 'Ver sellers'
  },
  equipment: {
    zh: '设备',
    en: '',
    pu: 'Equipamento'
  },
  generateOrder: {
    zh: '生成订单',
    en: '',
    pu: 'Gerar ordem'
  },
  editTitle: {
    zh: '编辑路线',
    en: '',
    pu: 'Editando Rota'
  },
  editParagraph: {
    zh: '请填写下方的字段以完成在我们系统中编辑路线的操作。',
    en: '',
    pu: 'Preencha os campos logo abaixo para realizar a edição de uma rota em nosso sistema'
  },
  sellerTitle: {
    zh: '卖家列表',
    en: '',
    pu: 'Lista de sellers'
  },
  sellerParagraph: {
    zh: '这是该路线所需收集的卖家列表，显示了卖家的代码和名称。',
    en: '',
    pu: 'Essa é a lista de sellers que essa rota tem para a coleta, mostrando o código e o nome do seller.'
  },
  equipmentTitle: {
    zh: '设备',
    en: '',
    pu: 'Equipamento'
  },
  equipmentParagraph: {
    zh: '填写所有字段以关联路线的设备。',
    en: '',
    pu: 'Preencha todos os campos para poder associar um equipamento a rota.'
  },
  orderTitle: {
    zh: '订单',
    en: '',
    pu: 'Ordem'
  },
  orderParagraph: {
    zh: '填写所有字段以在所选路线上生成订单。',
    en: '',
    pu: 'Preencha todos os campos para poder gerar um ordem nessa rota selecionada.'
  },

  // formEditRoute
  listSeller: {
    zh: '卖家列表',
    en: '',
    pu: 'Lista de sellers'
  },
  addSeller: {
    zh: '添加卖家',
    en: '',
    pu: 'Adicionar sellers'
  },
  sendButton: {
    zh: '发送',
    en: '',
    pu: 'Enviar'
  },

  // avaliableSellers
  sellerCode: {
    zh: '卖家代码',
    en: '',
    pu: 'Código do Seller'
  },
  sellerName: {
    zh: '卖家名称',
    en: '',
    pu: 'Nome do Seller'
  },
  sellerLabel: {
    zh: '卖家',
    en: '',
    pu: 'Seller'
  },
  cepLabel: {
    zh: '邮政编码',
    en: '',
    pu: 'CEP'
  },
  sellerQuantity: {
    zh: '卖家数量',
    en: '',
    pu: 'Quantidade de sellers'
  },
  sellerAlert: {
    zh: '请选择至少一个卖家',
    en: '',
    pu: 'Selecione pelo menos um seller'
  },

  // formDriver
  searchDriverTitle: {
    zh: '查找司机',
    en: '',
    pu: 'Procurar motorista'
  },
  nameLabel: {
    zh: '姓名',
    en: '',
    pu: 'Nome'
  },
  namePlaceholder: {
    zh: '输入司机姓名',
    en: '',
    pu: 'Digite o nome do motorista'
  },
  documentLabel: {
    zh: '个人/法人税号',
    en: '',
    pu: 'Documento'
  },
  usernameLabel: {
    zh: '用户名',
    en: '',
    pu: 'Nome de Usuário'
  },
  helpersLabel: {
    zh: '助手',
    en: '',
    pu: 'Ajudantes'
  },
  helpersPlaceholder: {
    zh: '选择助手',
    en: '',
    pu: 'Selecione os ajudantes'
  },
  createDriverTitle: {
    zh: '创建司机',
    en: '',
    pu: 'Criar motorista'
  },
  dataDriver: {
    zh: '司机数据',
    en: '',
    pu: 'Dados do motorista'
  },
  dataAddress: {
    zh: '地址数据',
    en: '',
    pu: 'Dados do endereço'
  },

  // formTransportSupply
  selectedColorsLabel: {
    zh: '选定的封条颜色',
    en: '',
    pu: 'Cores de lacre'
  },
  selectedColorsPlaceholder: {
    zh: '选择颜色',
    en: '',
    pu: 'Selecione as cores'
  },
  quantityBagsLabel: {
    zh: '袋子数量',
    en: '',
    pu: 'Qtd. Sacas'
  },
  quantityBagsPlaceholder: {
    zh: '输入袋子数量',
    en: '',
    pu: 'Digite a quantidade de sacas'
  },
  yellow: {
    zh: '黄色',
    en: '',
    pu: 'amarelo'
  },
  blue: {
    zh: '蓝色',
    en: '',
    pu: 'azul'
  },
  white: {
    zh: '白色',
    en: '',
    pu: 'branco'
  },
  pink: {
    zh: '粉色',
    en: '',
    pu: 'rosa'
  },
  colorPlaceholder: {
    zh: '输入封条编号',
    en: '',
    pu: 'Digite o número do lacre'
  },
  班次编号: {
    zh: '班次编号',
    en: '',
    pu: 'Número da Viagem'
  },
  对应揽收时间: {
    zh: '对应揽收时间',
    en: '',
    pu: 'Tempo de Coleta Correspondente'
  },
  对应揽收装车完成时间: {
    zh: '对应揽收装车完成时间',
    en: '',
    pu: 'Tempo Correspondente de Conclusão da Carga da Coleta'
  },
  对应HUB1到件时间: {
    zh: '对应HUB1到件时间',
    en: '',
    pu: 'Tempo de Chegada no HUB1 Correspondente'
  },
  发车时间: {
    zh: '发车时间',
    en: '',
    pu: 'Hora de Partida'
  },
  下一站流向: {
    zh: '下一站流向',
    en: '',
    pu: 'Próximo Fluxo de Destino'
  },
  选择班次: {
    zh: '选择班次',
    en: '',
    pu: 'Selecionar Viagem'
  },
  '揽收装车完成时间,HUB1到件时间, 不能小于揽收结束时间': {
    zh: '揽收装车完成时间,HUB1到件时间, 不能小于揽收结束时间',
    en: '',
    pu: 'O tempo de conclusão da carga da coleta e o tempo de chegada no HUB1 não podem ser menores que o tempo de término da coleta.'
  },
  新增班次: {
    zh: '新增班次',
    en: '',
    pu: 'Adicionar turno'
  },
  对应揽收时间不能大于对应揽收装车完成时间: {
    zh: '对应揽收时间不能大于对应揽收装车完成时间',
    en: '',
    pu: 'O tempo de coleta correspondente não pode ser maior que o tempo de conclusão da carga da coleta correspondente.'
  },
  新增流向: {
    zh: '新增流向',
    en: '',
    pu: 'Adicionar fluxo'
  },
  新增干支线流向: {
    zh: '新增干支线流向',
    en: '',
    pu: 'Adicionar fluxo de linha-dry'
  },
  CannotBeLessThanTheMaximumValue: {
    zh: '不能小于对应揽收时间的最大值',
    en: 'Cannot be less than the maximum value of the corresponding collection time',
    pu: 'Não pode ser menor que o valor máximo do horário de coleta correspondente'
  },
  correspondingHUB1: {
    zh: '不能大于对应HUB1到件时间',
    en: 'Cannot exceed the corresponding HUB1 delivery time',
    pu: 'Não pode ser mais maior que o horário de chegada correspondente ao HUB1'
  },
  CannotBeLessThanTheCorresponding: {
    zh: '不能小于对应揽收装车完成时间',
    en: 'Cannot be less than the corresponding collection and loading completion time',
    pu: 'Não pode ser menor que o tempo de conclusão da carga da coleta correspondente'
  },
  flowName: {
    zh: '流向名称',
    en: 'Flow Name',
    pu: 'Nome do Fluxo'
  },
  departureTransferCenter: {
    zh: '发车转运中心',
    en: 'Departure Transfer Center',
    pu: 'Centro de Transferência de Partida'
  },
  trunkLine: {
    zh: '干支线',
    en: 'Trunk Line',
    pu: 'Linha Tronco'
  },
  selectTrunkLine: {
    zh: '选择干支线',
    en: 'Select Trunk Line',
    pu: 'Selecionar Linha Tronco'
  },
  selectSchedule: {
    zh: '选择班次',
    en: 'Select Schedule',
    pu: 'Selecionar Horário'
  },
  latestArrivalTime: {
    zh: '最晚到达时间',
    en: 'Latest Arrival Time',
    pu: 'Hora de Chegada Máxima'
  },
  estimatedArrivalTime: {
    zh: '预计到达时间',
    en: 'Estimated Arrival Time',
    pu: 'Hora Prevista de Chegada'
  },
  crossDay: {
    zh: '是否跨天',
    en: 'Cross Day',
    pu: 'Cruzar Dia'
  },
  executionResult: {
    zh: '执行结果',
    en: 'Execution Result',
    pu: 'Resultado da Execução'
  },
  totalImportedData: {
    zh: '总导入数据',
    en: 'Total Imported Data',
    pu: 'Total de Dados Importados'
  },
  downloadFailedData: {
    zh: '下载失败数据',
    en: 'Download Failed Data',
    pu: 'Dados de Download com Falha'
  },
  pleaseUploadFile: {
    zh: '请上传文件',
    en: 'Please Upload File',
    pu: 'Por favor Carregar Arquivo'
  },
  DepartureTimeRange: {
    zh: '应发件时间范围',
    en: 'Time range for sending documents',
    pu: 'Intervalo de tempo para envio'
  },
  PreviousDay: {
    zh: '前一天',
    en: 'Previous day',
    pu: 'Dia Anterior'
  },
  ThisAreaCollectsPackages: {
    zh: '本场地集包',
    en: 'This area collects packages',
    pu: 'Este local coleta pacotes'
  },
  CollectionTime: {
    zh: '集包时间',
    en: 'Collection Time',
    pu: 'Tempo de Coleta'
  },
  PredictNextStop: {
    zh: '预测下一站',
    en: 'Predict Next Stop',
    pu: 'Prever Próximo Destino'
  },
  NumberBagsSent: {
    zh: '应发袋数',
    en: 'Number of bags to be sent',
    pu: 'Número de sacos'
  },
  NumberOfSentBags: {
    zh: '已发袋数',
    en: 'Number of sent bags',
    pu: 'Número de sacos'
  },
  NumberItemsToBeSent: {
    zh: '应发件数',
    en: 'Number of items to be sent',
    pu: 'Número de envios'
  },
  NumberOfSentItems: {
    zh: '已发件数',
    en: 'Number of sent items',
    pu: 'Número de envios'
  },
  LatestOperationInThisArea: {
    zh: '本场地最新操作',
    en: 'Latest operation in this area',
    pu: 'Última operação neste local'
  },
  LatestOperationTimeInThisArea: {
    zh: '本场地最新操作时间',
    en: 'Latest operation time in this area',
    pu: 'Hora da Última Operação neste Local'
  },
  WhetherToLeave: {
    zh: '是否离场',
    en: 'Whether to leave',
    pu: 'Se for sair'
  },
  IsThisAreaLoading: {
    zh: '本场地是否装车',
    en: 'Is this area loading?',
    pu: 'Este local está carregando?'
  },
  AddNewRulesForItemsToBeSent: {
    zh: '新增应发件规则',
    en: 'Add new rules for items to be sent',
    pu: 'Adicionar regra de envio'
  },
  EditRulesForItemsToBeSent: {
    zh: '编辑应发件规则',
    en: 'Edit rules for items to be sent',
    pu: 'Editar regra de envio'
  },
  packageConsolidationRecords: {
    zh: '集包操作记录',
    en: 'Package Consolidation Records',
    pu: 'Registros de Consolidação de Pacotes'
  },
  sorterConsolidation: {
    zh: '分拣机集包',
    en: 'Sorter Consolidation',
    pu: 'Consolidação por Classificador'
  },
  manualConsolidation: {
    zh: '手工集包',
    en: 'Manual Consolidation',
    pu: 'Consolidação Manual'
  },
  forwardConsolidation: {
    zh: '正向集包',
    en: 'Forward Consolidation',
    pu: 'Consolidação Direta'
  },
  returnConsolidation: {
    zh: '退件集包',
    en: 'Return Consolidation',
    pu: 'Consolidação de Devolução'
  },
  consolidationOperationHub: {
    zh: '集包操作网点',
    en: 'Consolidation Operation Hub',
    pu: 'Centro de Operação de Consolidação'
  },
  loadingCompletionTime1: {
    zh: '装车完成时间-1',
    en: 'Loading Completion Time-1',
    pu: 'Tempo de Conclusão do Carregamento-1'
  },
  licensePlateNumber1: {
    zh: '车牌号-1',
    en: 'License Plate Number-1',
    pu: 'Número da Placa-1'
  },
  nextStation1: {
    zh: '下一站-1',
    en: 'Next Station-1',
    pu: 'Próxima Estação-1'
  },
  unloadingTime1: {
    zh: '卸车时间-1',
    en: 'Unloading Time-1',
    pu: 'Tempo de Descarregamento-1'
  },
  loadingCompletionTime2: {
    zh: '装车完成时间-2',
    en: 'Loading Completion Time-2',
    pu: 'Tempo de Conclusão do Carregamento-2'
  },
  licensePlateNumber2: {
    zh: '车牌号-2',
    en: 'License Plate Number-2',
    pu: 'Número da Placa-2'
  },
  nextStation2: {
    zh: '下一站-2',
    en: 'Next Station-2',
    pu: 'Próxima Estação-2'
  },
  unloadingTime2: {
    zh: '卸车时间-2',
    en: 'Unloading Time-2',
    pu: 'Tempo de Descarregamento-2'
  },
  loadingCompletionTime3: {
    zh: '装车完成时间-3',
    en: 'Loading Completion Time-3',
    pu: 'Tempo de Conclusão do Carregamento-3'
  },
  licensePlateNumber3: {
    zh: '车牌号-3',
    en: 'License Plate Number-3',
    pu: 'Número da Placa-3'
  },
  nextStation3: {
    zh: '下一站-3',
    en: 'Next Station-3',
    pu: 'Próxima Estação-3'
  },
  unloadingTime3: {
    zh: '卸车时间-3',
    en: 'Unloading Time-3',
    pu: 'Tempo de Descarregamento-3'
  },
  loadingCompletionTime: {
    zh: '装车完成时间',
    en: 'Loading Completion Time',
    pu: 'Tempo de Conclusão do Carregamento'
  },
  packageConsolidationDetails: {
    zh: '集包详情',
    en: 'Package Consolidation Details',
    pu: 'Detalhes da Consolidação de Pacotes'
  },
  consolidationOperator: {
    zh: '集包操作人',
    en: 'Consolidation Operator',
    pu: 'Operador de Consolidação'
  },
  loadingFinishTime: {
    zh: '装车完成时间',
    en: 'Loading Finish Time',
    pu: 'Tempo de Conclusão do Carregamento'
  },
  unloadingOperator: {
    zh: '卸车操作人',
    en: 'Unloading Operator',
    pu: 'Operador de Descarregamento'
  },
  loadingOperator: {
    zh: '装车操作人',
    en: 'Loading Operator',
    pu: 'Operador de Carregamento'
  },
  transportationCount01: {
    zh: '第',
    en: '',
    pu: '#'
  },
  transportationCount02: {
    zh: ' 次运输',
    en: '',
    pu: ' Transporte'
  }
};
